import { Link } from "react-router-dom";
import { Twitter, Facebook, Instagram, Youtube } from "lucide-react";
import Logo from "@/components/Logo";

const cols = [
  {
    title: "Platform",
    links: [
      ["Reading Practice", "/practice"],
      ["Vocabulary", "/vocabulary"],
      ["Test-Taking Lab", "/test-lab"],
      ["SAT / ACT / AP", "/sat-prep"],
      ["Annotation AI", "/annotator"],
      ["Fluency Studio", "/fluency"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About", "/about"],
      ["Pricing", "/pricing"],
      ["Contact", "/contact"],
      ["Blog", "/blog"],
      ["Reading topics", "/reading"],
    ],
  },
  {
    title: "Resources",
    links: [
      ["Parent Resources", "/insights"],
      ["Teacher Resources", "/insights"],
      ["FAQ", "/faq"],
      ["Support", "/contact"],
      ["Accessibility", "/accessibility"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Policy", "/privacy"],
      ["Terms of Service", "/terms"],
      ["Accessibility", "/accessibility"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-secondary/40" data-testid="site-footer">
      <div className="container-spark py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo variant="footer" />
            <p className="mt-4 max-w-sm text-sm text-muted-foreground leading-relaxed">
              Read with purpose. Think with precision.
            </p>
            <p className="mt-2 max-w-sm text-xs text-muted-foreground/80">
              Adaptive AI-powered literacy for every reader.
            </p>
            <div className="mt-6 flex gap-3" aria-label="Social links">
              {[Twitter, Facebook, Instagram, Youtube].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  className="grid h-9 w-9 place-items-center rounded-full border border-border hover:bg-background transition"
                  aria-label="Social link"
                  data-testid={`footer-social-${i}`}
                >
                  <I size={16} />
                </a>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="text-xs font-bold uppercase tracking-[0.18em] text-muted-foreground">
                {c.title}
              </div>
              <ul className="mt-4 space-y-2">
                {c.links.map(([label, to]) => (
                  <li key={label}>
                    <Link
                      to={to}
                      className="text-sm text-foreground/80 hover:text-spark-purple transition"
                      data-testid={`footer-link-${label.replace(/\s+/g, "-").toLowerCase()}`}
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-border flex flex-col md:flex-row gap-2 items-center justify-between text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} SparkRead. A companion of WritersSpark.net.</div>
          <div>
            <a href="mailto:info@sparkread.net" className="hover:text-spark-purple transition" data-testid="footer-email">
              info@sparkread.net
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
